<div
  class="relative h-full flex justify-between flex-col rounded-lg bg-white shadow-S overflow-hidden cursor-pointer"
  [ngClass]="{
    'opacity-50': !asset.is_usable,
  }"
>
  <div>
    <img
      *ngIf="asset.image"
      [src]="asset.image"
      alt="img"
      class="w-full rounded-t-lg h-24 max-h-24 w-full object-cover"
    />
  </div>
  <div class="px-3 py-2 pb-3 h-full text-sm flex flex-col justify-start">
    <p class="font-accent text-neutral-800 font-normal">{{ asset.name }}</p>
    <div class="text-sm font-bold">
      {{ assetTagText(asset) | translate }}
    </div>
    <p class="font-base text-neutral-600 font-normal text-xs pt-1 line-clamp-3">
      {{ asset.description }}
    </p>
    <p
      *ngIf="!asset.is_usable"
      class="mt-2 font-bold"
    >
      {{ 'como.asset-available-in-points' | translate: { points: asset.points_remaining / 100 } }}
    </p>
  </div>
  <div
    *ngIf="asset.is_usable && displayAddButton"
    class="mb-4 flex flex-col items-center justify-center"
  >
    <div
      *ngIf="isAssetInCart"
      class="flex flex-row items-center justify-center mb-2 font-normal text-sm leading-snug lg:text-base"
    >
      <i class="icon icon-check-circle text-success-600 mr-2"></i>
      {{ 'como.asset-added-to-cart' | translate }}
    </div>
    <app-button-atom
      *ngIf="!isAssetInCart"
      [label]="'como.use-voucher' | translate"
      (click)="onAssetAdd(asset)"
      icon="icon-plus"
      size="XS"
      thickSize="XS"
      type="outlined"
      color="neutral"
    ></app-button-atom>
    <app-button-atom
      *ngIf="isAssetInCart"
      [label]="'como.remove-voucher' | translate"
      (click)="onAssetRemove(asset)"
      icon="icon-c-remove"
      size="XS"
      thickSize="XS"
      type="outlined"
      color="neutral"
    ></app-button-atom>
  </div>
</div>
